import http from 'plugins/axios';

export default {
  getList() {
    return http.get({
      url: '/la/admin/site/conf/functionUrl/list'
    });
  },
  addConfig(data) {
    return http.post({
      url: '/la/admin/site/conf/functionUrl/add',
      data
    });
  },
  updateConfig(data) {
    return http.post({
      url: '/la/admin/site/conf/functionUrl/update',
      data
    });
  },
  deleteConfig(confKey) {
    return http.post({
      url: `/la/admin/site/conf/functionUrl/del?confKey=${encodeURIComponent(confKey)}`
    });
  }
};
